import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import store from '@/redux/store';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import ReactGA from "react-ga";
import { BrowserRouter } from "react-router-dom";
import App from './App';

//GA配置
ReactGA.initialize([
  { trackingId: "UA-208519089-1", gaOptions: { name: "AccountTracker" } },
  // { trackingId: "UA-177200317-10", gaOptions: { name: "Tracker" } },
]);
ReactGA.pageview(window.location.pathname);
ReactGA.set(
  {
    dimension1: 'window',
    dimension3: "none",
    dimension4: 'zh-cn'
  },
  ["AccountTracker"]
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    {/* 注意这里如果有层级目录的话,需要加上basename,否则拿到的路由匹配element 为 null basename='/account/'basename='/ad/account-test/'  */ }
    <BrowserRouter basename='/account/'>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
